/* eslint-disable no-underscore-dangle */
import React, {
  useState, useEffect, useContext, useCallback,
} from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import BaseContainer from '../common/BaseContainer';
import ControlHeader from '../common/ControlHeader';

import useCrudModals from '../common/FormModalContent/useCrudModals';
import {
  validationSchema, getRequestToFormData, getFormToRequestData, initialValues, baseUrl, formsInputsData,
} from './config';
import generateFormikInputs from '../../utils/generateFormikInputs';
import useStyles from './styles';
import CampaignsTable from './CampaignsTable';
import fetch from '../../utils/fetcher';
import ServerErrorMessage from '../common/ServerErrorMessage';
import { ModalManagerContext } from '../ModalsManager';
import {
  translateQuestionsDictionary,
  translateQuestionsReverseDictionary,
} from '../CampaignFormQuestionnaire/AddQuestionModalContent/questionTypesConsts';

const Campaigns = () => {
  const limit = 10;
  const { t } = useTranslation(['translation'])
  const [query, setQuery] = useState('');
  const [orderBy, setOrderBy] = useState('');
  const [page, setPage] = useState(1);
  const [ascending, setAscending] = useState(0);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const openModal = useContext(ModalManagerContext);

  const QUESTIONS_DICTIONARY = translateQuestionsDictionary(t);
  const QUESTIONS_REVERSE_DICTIONARY = translateQuestionsReverseDictionary(t);
  const formToRequestData = getFormToRequestData(QUESTIONS_DICTIONARY);
  const requestToFormData = getRequestToFormData(QUESTIONS_REVERSE_DICTIONARY);

  const update = useCallback(() => {
    const url = `${baseUrl}?query=${query}&orderBy=${orderBy}&ascending=${ascending}&limit=${limit}&page=${page}`;
    setData(null);
    setIsLoading(true);
    fetch(url).then(res => res.json()).then(resData => { setData(resData); })
      .catch(() => {
        openModal(ServerErrorMessage);
      })
      .finally(() => { setIsLoading(false); });
  }, [query, orderBy, ascending, limit, page, openModal]);

  useEffect(() => {
    update();
  }, [update]);


  const onOrderByChange = newOrderBy => {
    if (orderBy !== newOrderBy) {
      setOrderBy(newOrderBy);
    } else {
      setAscending(ascending === 1 ? 0 : 1);
    }
  };

  const classes = useStyles();
  const { openDeleteModal } = useCrudModals(
    openModal,
    {
      entity: t('CAMPAIGN.ENTITY_NAME'),
      baseUrl,
      requestToFormData,
      formToRequestData,
      initialValues,
      FormSchema: validationSchema,
      afterSuccecss: update,
      createFormComponent: formikProps => (
        <div className={classes.inputsGrid}>
          {generateFormikInputs(formsInputsData(t), formikProps)}
        </div>
      ),
    },
    classes.dialog,
  );

  const history = useHistory();
  return (
    <BaseContainer>
      <ControlHeader
        title={t('CAMPAIGN.TITLE_TAB')}
        showAdd
        // showSearch
        onSearch={setQuery}
        onAdd={() => { history.push('/campaigns/new'); }}
        showTabs
        activeTab="campaigns"
      />
      <CampaignsTable
        isLoading={isLoading}
        data={data}
        limit={limit}
        page={page}
        orderBy={orderBy}
        ascending={ascending}
        onOrderByChange={onOrderByChange}
        setPage={setPage}
        openDeleteModal={openDeleteModal}
      />
    </BaseContainer>
  );
};


export default Campaigns;
